
import { timeRangeOptions, saleOrderStatus, stateOptionBoolean } from "@/utils/options";


const dateTypeOptions = [
    {id: 'purchaseDate', text: '订购时间'},
    {id: 'recordDate', text: '记录时间'}
]

export default () => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '国家店铺',
    prop: 'countryMarketValue',
    components: [{
        name: 'gj-country-server-select',
        prop: 'countryMarketValue'
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: {
        countryIds: [],
        marketIds: []
    }
}, {
    label: '状态',
    prop: 'orderStatusList',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'orderStatusList',
        propsData: {
            options: saleOrderStatus,
            placeholder: '全部状态',
            type: 'multi-check'
        }
    }],
    defaultValue: []
}, {
    label: '是否录入费用',
    prop: 'promoteFee',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'promoteFee',
        propsData: {
            options: stateOptionBoolean,
            placeholder: '是否录入费用'
        }
    }],
    defaultValue: ''
},{
    label: '是否退款',
    prop: 'refunded',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'refunded',
        propsData: {
            options: stateOptionBoolean,
            placeholder: '是否退款'
        }
    }],
    defaultValue: ''
}, {
    label: '全部品类',
    prop: 'categoryIds',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-category-select',
        prop: 'categoryIds',
        propsData: {
            placeholder: '全部品类',
            multiple: true
        }
    }],
    defaultValue: []
},  {
    label: '时间范围',
    prop: 'dateRange',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'dateType',
        propsData: {
            placeholder: '时间类型',
            options: dateTypeOptions
        }
    }, {
        name: 'gj-select',
        prop: 'dateRange',
        propsData: {
            placeholder: '时间范围',
            options: timeRangeOptions,
            style: {
                marginLeft: '8px'
            }
        }
    }],
    validator: [
        {required: true, message: '请选择日期', trigger: 'change'}
    ]
}, {
    prop: 'dateType',
    defaultValue: 'purchaseDate'
}]
